import React, { ReactElement } from "react";
import TinySlider from "tiny-slider-react";

import spriteSVG from "../assets/img/svg/sprite.svg";

interface CleaningActionImageSliderProps {
  readonly images: Array<string>;
  onIndexChanged: (slide: any) => void;
}

export default function CleaningActionImageSlider({
  images,
  onIndexChanged,
}: CleaningActionImageSliderProps): ReactElement {
  const customControls = [
    `
    <svg class="control-icon sprite-icon">
      <use xlink:href=${spriteSVG}#arrow-left />
    </svg>
    `,
    `
    <svg class="control-icon sprite-icon">
      <use xlink:href=${spriteSVG}#arrow-right />
    </svg>
    `,
  ];

  const sliderOptions = {
    items: 1,
    slideBy: "page" as "page",
    mouseDrag: true,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    autoplayButtonOutput: false,
    nav: false,
    navPosition: "bottom",
    gutter: 0,
    swipeAngle: false,
    controlsText: customControls,
    autoWidth: false,
  };

  return (
    <TinySlider settings={sliderOptions} onIndexChanged={onIndexChanged}>
      {images.map((imageSrc, index) => (
        <div key={index} className="cleaners-slider__item">
          <div className="cleaners-slider__item-photo">
            <picture>
              <source srcSet={imageSrc} type="image/webp" />
              <img
                src={imageSrc}
                data-src={imageSrc}
                alt={`Cleaners ${index}`}
                className="cleaners-slider__item-photo-img cover-pic"
              />
            </picture>
          </div>
        </div>
      ))}
    </TinySlider>
  );
}
